<template>
    <b-modal
        id="message-seller-modal"
        title="Message Seller"
        dialog-class="message-seller-modal"
    >

        <div class="mb-3" v-if="orderComplete">
            <div class="mb-3" v-if="orderComplete">
                Send instructions to make disclosure edits.
            </div>
        </div>
        <div class="mb-3" v-else>
            <p>Select a reminder message to send to your client:</p>
            <b-form-checkbox
                class="custom-checkbox"
                name="sort" 
                v-model="messageType" 
                value="reminder-to-sign-disclosure-v3"
                v-if="orderAwaitingSignatures" > 
                Remind seller to sign disclosure form(s). 
            </b-form-checkbox> 
            <b-form-checkbox 
                class = "custom-checkbox"
                name="sort" 
                v-model="messageType" 
                value="reminder-to-finish-disclosure-v3" >
                Remind seller to finish disclosure form(s). 
            </b-form-checkbox>
        </div>

        <div v-if="messageType">
            <p>
                <strong>The following will be sent to the seller:</strong>
            </p>
            <div class="text-container" v-if="messageType === 'instructions-to-edit-disclosure-v3'">
                <div class="text-body">
                    <p class="quote-text">
                        Dear {{ getPrimarySellerForSelectedOrderFromStore.firstName }}, <br/>
                        It appears you need to make edits to your disclosure form. <br/>
                        To go back and edit your answers please click the "Edit disclosure" button and follow the steps
                        below:
                    </p>
                    <ol>
                        <li>Select the "edit" button on your dashboard.</li>
                        <li>Use the navigation bar to quickly locate and edit the disclosure sections</li>
                    </ol>
                </div>
            </div>
            <div v-else-if="messageType === 'reminder-to-sign-disclosure-v3'">
                <div class="text-container">
                    <div class="text-body">
                        <p class="quote-text">
                            Dear {{ getPrimarySellerForSelectedOrderFromStore.firstName }}, <br/>
                            You're almost finished! You've done the heavy lifting; now all that's left is signing your
                            completed disclosure form.
                        </p>
                    </div>
                </div>
                <p>Your seller will be provided with a button in the email to access the review page and sign.</p>
            </div>
            <div v-else-if="messageType === 'reminder-to-finish-disclosure-v3'">
                <div class="text-container">
                    <div class="text-body">
                        <p class="quote-text">
                            Dear {{ getPrimarySellerForSelectedOrderFromStore.firstName }}, <br/>
                            Don’t forget, you have started your seller’s disclosure but are not yet finished! Please
                            remember this is a legal document and needs to be completed before the sale of your home.
                        </p>
                    </div>
                </div>
                <p>Your seller will be provided a button in the email to access their disclosure.</p>
            </div>
        </div>
        <template #modal-footer>        
            <b-button
                variant="outline-dark"
                @click="$bvModal.hide(id)"
            >
                Cancel
            </b-button>
            <b-button
                class="save-modal"
                variant="primary"
                :disabled="!messageType"
                @click="messageSeller"
            >
                Send Message
            </b-button>
        </template>
    
    </b-modal>
</template>

<script>
import ShowNotificationMixin from "@sellers-shield-home-protection/ss-ui-kit/src/mixins/ShowNotificationMixin";
import {orderStatus, statusOrder} from "@helpers/order";
import './MessageSellerModal.scss';
import {mapState, mapActions} from 'pinia';
import {useAuthStore, useLookupsStore, useOrdersStore} from '@store';


export default {
    name: "MessageSellerModal",
    mixins: [
        ShowNotificationMixin,
    ],
    props: {
        id: {
            type: String,
            default: 'message-seller-modal',
        },
        order: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        messageType: null,
        quoteImage: require('@assets/images/quote-mark.png')
    }),
    computed: {
        ...mapState(useOrdersStore, {
            getSelectedOrderFromStore: 'getSelectedOrder',
            getSellersForSelectedOrder:'getSellersForSelectedOrder',
            getPrimarySellerForSelectedOrderFromStore: 'getPrimarySellerForSelectedOrder',
        }),
        orderStatus() {
            return orderStatus(this.getSelectedOrderFromStore);
        },
        orderComplete() {
            return this.orderStatus === statusOrder.COMPLETE;
        },
        orderUpdatesInProgress() {
            return this.orderStatus === statusOrder.DISCLOSURE_UPDATES_IN_PROGRESS;
        },
        orderAwaitingSignatures() {
            return this.orderStatus === statusOrder.AWAITING_SIGNATURES;
        },
    },
        created() {
            this.setMessageTypeBasedOnOrderStatus();
        },
    methods: {
        messageSeller() {
            try {
                this.order.messageSeller(this.messageType);
                this.$bvModal.hide('message-seller-modal');
            } catch (e) {
                console.error(e);
                this.showNotification({
                    message: 'Something went wrong. Please try again later',
                    type: 'error'
                });
            }
        },
        setMessageTypeBasedOnOrderStatus() {
            if (this.orderComplete) {
                this.messageType = 'instructions-to-edit-disclosure-v3';
            }else if(!this.orderAwaitingSignatures){
                this.messageType = 'reminder-to-finish-disclosure-v3';
            }
        }
    },
}
</script>